/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import axios from 'axios';

//import TimeBlock from '../containers/timeline/TimeBlock';
import dateFormat from 'dateformat';
//import PerfectScrollbar from 'react-perfect-scrollbar';
import WeekBlock from '../containers/timeline/WeekBlock';
//import ScrollMenu from 'react-horizontal-scrolling-menu';
//import { StickyContainer, Sticky } from 'react-sticky';
//import  ScrollArea  from 'react-scrollbar';
//import { StickyContainer, Sticky } from 'react-sticky';
import $ from 'jquery';
import moment from 'moment';
class TimeLineTv extends Component {
  state = {
    mouseOn: false,
    slideIndex: 1,
    curDate: new Date(),
    bWidth: isMobile ? 390 : 1920,
  };
  componentDidMount = () => {
    const { curDate } = this.state;

    var body = document.querySelector('body');
    body.addEventListener('click', this.clickBodyEvent);
    window.addEventListener('resize', this._onLine);

    this._getTimeline(curDate);

    //let curDate = new Date()
    let temp = dateFormat(curDate, 'yyyymmdd');

    this._setWeekDate(temp);
    const curHour = curDate.getHours(); // 시
    const scrollPos = curHour * 531;

    setTimeout(() => {
      this._onLine();
      var target = $('.pairing_height');
      target.animate({ scrollTop: scrollPos }, 2000);
    }, 1000);
  };
  componentWillUnmount = () => {
    var body = document.querySelector('body');
    body.removeEventListener('click', this.clickBodyEvent);
    window.removeEventListener('resize', this._onLine);
  };
  clickBodyEvent = (event) => {
    var target = event.target;
    var eventTarget = event.currentTarget.querySelector('.pairing_content');

    //console.log(target, eventTarget)

    if (target === eventTarget) {
      this._onClose();
    } else {
    }
  };
  _onLine = () => {
    var firstOp = true;

    var line = $('.on_box');
    var target = $('.div_li.on');
    var targetLeft = target.position().left;
    line.css({ width: target.width(), left: targetLeft });
    if (firstOp === true) {
      line.css('opacity', '1');
      firstOp = false;
    }

    this.setState({
      bWidth: window.innerWidth,
    });
  };
  _getTimeline = async (curDate) => {
    const result = await this._getTimelineApi(curDate);
    const intReturn = result.data[0].intReturn;
    const timelineList = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        timelineList,
        curDate,
      });
    }
  };

  _getTimelineApi = (curDate) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/timelineTv', {
        params: {
          curDate: moment(curDate).format('YYYY-MM-DD HH:mm:ss'),
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = (day, hour) => {
    const { timelineList } = this.state;
    const timeline = [];
    timelineList.filter((item, index) => {
      ////console.log(item.startDate.substr(0, 10))
      if (day === item.startDate.substr(0, 10) && item.hh === hour) {
        timeline.push(item);
        ////console.log(item.hh)
      }
    });
    return timeline;
    ////console.log(timeline)
  };
  _setWeekDate = (selectDate) => {
    var year = selectDate.substring(0, 4); //선택된 년도
    var month = selectDate.substring(4, 6); //선택된 월
    var day = selectDate.substring(6, 8); //선택된 일자
    //var week  = new Array("", "월", "화", "수", "목", "금", "토", "일");

    let currentDay = new Date(year, month - 1, day);
    var theDayOfWeek = currentDay.getDay();

    if (theDayOfWeek === 0) {
      currentDay = new Date(year, month - 1, day - 7);
    }

    var theYear = currentDay.getFullYear();
    var theMonth = currentDay.getMonth();
    var theDate = currentDay.getDate();
    var thisWeek = [];

    for (var i = 1; i < 8; i++) {
      var resultDay = new Date(theYear, theMonth, theDate + (i - theDayOfWeek));
      var yyyy = resultDay.getFullYear();
      var mm = Number(resultDay.getMonth()) + 1;
      var dd = resultDay.getDate();
      //var dd_nm = resultDay.getDay();

      mm = String(mm).length === 1 ? '0' + mm : mm;
      dd = String(dd).length === 1 ? '0' + dd : dd;

      //월요일부터 화, 수 ~ 일요일까지 날짜를 담음
      thisWeek[i] = yyyy + '-' + mm + '-' + dd;
      if (i === 1) {
        // 검색기준 월요일
      } else if (i === 7) {
        // 검색기준 일요일
      }
    }
    //console.log(thisWeek)

    this.setState({
      thisWeek,
      theDate,
      theDayOfWeek,
    });
  };
  _renderWeek = () => {
    const { thisWeek, theDayOfWeek, bWidth } = this.state;
    const curDate = new Date().getDate();
    console.log(thisWeek);
    const mobileList = thisWeek.slice(theDayOfWeek);
    console.log(mobileList);
    let list;
    if (bWidth <= 1024) {
      list = mobileList.map((item, index) => {
        return (
          <h2
            onClick={() => this._selectWeek(index, item)}
            key={index}
            className={
              parseInt(curDate) === parseInt(item.substr(8, 2)) ? 'on' : null
            }
            style={{ cursor: 'pointer' }}
          >
            {item.substr(5, 6)}{' '}
            <span>
              {index === 1
                ? '월'
                : index === 2
                ? '화'
                : index === 3
                ? '수'
                : index === 4
                ? '목'
                : index === 5
                ? '금'
                : index === 6
                ? '토'
                : index === 7
                ? '일'
                : null}
            </span>
          </h2>
          /*<h2 key={index} className={index === theDayOfWeek ? 'on' : null }>{item.substr(5, 6)} <span>{index===1 ? '월' : index===2 ? '화' : index===3 ? '수' : index===4 ? '목' : index===5 ? '금' : index===6 ? '토' : index===7 ? '일' : null}</span></h2>*/
        );
      });
    } else {
      list = thisWeek.map((item, index) => {
        return (
          <h2
            onClick={() => this._selectWeek(index, item)}
            key={index}
            className={
              parseInt(curDate) === parseInt(item.substr(8, 2)) ? 'on' : null
            }
            style={{ cursor: 'pointer' }}
          >
            {item.substr(5, 6)}{' '}
            <span>
              {index === 1
                ? '월'
                : index === 2
                ? '화'
                : index === 3
                ? '수'
                : index === 4
                ? '목'
                : index === 5
                ? '금'
                : index === 6
                ? '토'
                : index === 7
                ? '일'
                : null}
            </span>
          </h2>
          /*<h2 key={index} className={index === theDayOfWeek ? 'on' : null }>{item.substr(5, 6)} <span>{index===1 ? '월' : index===2 ? '화' : index===3 ? '수' : index===4 ? '목' : index===5 ? '금' : index===6 ? '토' : index===7 ? '일' : null}</span></h2>*/
        );
      });
    }

    // console.log(list);

    return list;
  };
  _onToggleMouseOn = () => {
    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    this.setState({
      mouseOn: false,
    });
  };
  _arrowNext = () => {
    const { slideIndex, thisWeek } = this.state;
    const cnt = thisWeek.length;
    const page = Math.round(cnt / 7);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    //const cnt = thisWeek.length;
    //const page = Math.round(cnt / 7)

    //if(slideIndex <= 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _onSelect = (key) => {
    const { invenList } = this.state;
    //console.log(key)
    //console.log(invenList[key].sample_img)

    this.setState({
      afterChar: invenList[key].sample_img,
      cidx: invenList[key].cidx,
    });
  };
  _next = () => {
    //alert(0)
    //this.scrollbar.scrollTop = 500;
    const { curDate } = this.state;
    const nextDate = moment(curDate).add(1, 'day'); //.format('YYYY-MM-DD-HH:mm:ss')

    this._getTimeline(nextDate);

    let temp = moment(nextDate).format('YYYYMMDD');
    this._setWeekDate(temp);
    setTimeout(() => {
      this._onLine();
    }, 100);
  };
  _prev = () => {
    const { curDate } = this.state;
    const prevDate = moment(curDate).add(-1, 'day'); //.format('YYYY-MM-DD-HH:mm:ss')

    this._getTimeline(prevDate);

    let temp = moment(prevDate).format('YYYYMMDD');
    this._setWeekDate(temp);
    setTimeout(() => {
      this._onLine();
    }, 100);
  };
  _selectWeek = (week, theDate) => {
    //console.log(theDate)
    const clickDate = new Date(theDate);

    this._getTimeline(clickDate);

    let temp = moment(clickDate).format('YYYYMMDD');
    this._setWeekDate(temp);

    setTimeout(() => {
      this._onLine();
    }, 100);

    let val;
    if (week === 7) {
      val = 0;
    } else {
      val = week;
    }
    this.setState({
      week: val,
    });
  };
  _onClose = () => {
    const { setTvline } = this.props;
    setTvline(false);
  };
  _channelInfo = () => {
    const { setChannelShow } = this.props;
    //setTvline(false)
    setChannelShow(true);
  };
  render() {
    const { timelineList, thisWeek, theDayOfWeek } = this.state;
    const { imgUrl } = this.props;
    //const { imgUrl } = this.props;
    ////console.log(timelineList)
    return (
      <Fragment>
        {timelineList ? (
          <div className="detail_layer_pop">
            <div className="pairing_content">
              <div className="close_btn">
                <a style={{ cursor: 'pointer' }} onClick={this._onClose}>
                  닫기
                </a>
              </div>
              <div className="pairing_group">
                {/*
                            <div className="right_btn">
                                <a href="#"><img src="/img/etc/download_btn.jpg"/></a>
                                <a href="#"><img src="/img/etc/embed_btn.png"/></a>
                            </div>
                            */}
                <h1>
                  TV채널 편성표{' '}
                  <span>내부사정에 따라 편성이 변경될 수 있습니다.</span>
                  <a style={{ cursor: 'pointer' }} onClick={this._channelInfo}>
                    지역별 채널안내
                  </a>
                </h1>

                <div className="pairing_box">
                  <div className="on_box">
                    <div className="on_line1"></div>
                    <div className="on_line2"></div>
                    <div className="on_line3"></div>
                    <div className="on_line4"></div>
                  </div>

                  <div className="float_right">
                    <span className="table_img">
                      <img src={imgUrl + '/img/etc/table_img.png'} />
                    </span>
                    <div className="pairing_table">
                      <div className="margin_lelft_width">
                        <a
                          className="pre_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._prev}
                        >
                          이전
                        </a>
                        <a
                          className="next_btn"
                          style={{ cursor: 'pointer' }}
                          onClick={this._next}
                        >
                          다음
                        </a>

                        <div className="pairing_data">
                          {thisWeek ? this._renderWeek() : null}
                        </div>
                      </div>
                      <div className="s_on_line1"></div>
                      <div className="s_on_line2"></div>
                      <div className="s_on_line3"></div>
                      <div className="s_on_line4"></div>
                      <div className="s_on_line5"></div>
                      <div className="s_on_line6"></div>
                      <div className="s_on_line7"></div>
                      <div className="pairing_height">
                        {/*00시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={0}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*01시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={1}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*02시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={2}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*03시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={3}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*04시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={4}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={5}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={6}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={7}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={8}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={9}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={10}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={11}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={12}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={13}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={14}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={15}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={16}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={17}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={18}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={19}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={20}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={21}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={22}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                        {/*05시*/}
                        <WeekBlock
                          renderItem={this._renderItem}
                          thisWeek={thisWeek}
                          hour={23}
                          theDayOfWeek={theDayOfWeek}
                          part="tv"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*<div className="pairing_baner"><img src="/img/etc/pairing_baner.jpg"/></div>*/}
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TimeLineTv));
